import compose from 'recompose/compose';
import mapProps from 'recompose/mapProps';
import { connect } from 'react-redux';
import {
  getActivePage,
  setBookPreviewActivePage,
  getImageWidth,
} from '../duck';
import ScrollingBook from './ScrollingBook';

const enhance = compose(
  mapProps(props => ({
    ...props,
    pages: props.pages.reduce(
      (pages, page, i) =>
        props.hasInsideCovers && (i === 1 || i === props.pages.length - 2)
          ? pages
          : pages.concat(page),
      [],
    ),
  })),
  connect(
    state => ({
      activePage: getActivePage(state),
      imageWidth: getImageWidth(state),
    }),
    dispatch => ({
      setActivePage: page => dispatch(setBookPreviewActivePage(page)),
    }),
  ),
);

export default enhance(ScrollingBook);



// WEBPACK FOOTER //
// ./src/client/js/view/components/BookPreview/ScrollingBook/index.js